import React from "react"
import { FormControlLabel, Checkbox, checkboxClasses } from "@carrotfertility/carotene-core"
import { FormCheckboxGroup, FormCheckBoxGroupProps, useWatch } from "@carrotfertility/carotene-core-x"
import { DoAnyApplyOption } from "#/components/carrot-plans/types/doAnyApplyOption"

interface RoutingFlowCheckboxGroupProps extends FormCheckBoxGroupProps {
  maxSelections?: number
}

export function RoutingFlowCheckboxGroup({
  name,
  options,
  maxSelections,
  ...otherProps
}: RoutingFlowCheckboxGroupProps): JSX.Element {
  const selectedOptions = useWatch({ name }) || []
  const isNoneOfTheAboveSelected = selectedOptions.includes(DoAnyApplyOption.NONE)
  const hasOtherSelections = selectedOptions.some((option: string) => option !== DoAnyApplyOption.NONE)

  return (
    <FormCheckboxGroup
      {...{ name, options }}
      {...otherProps}
      renderItem={({ formControlLabelProps, checkboxProps }) => (
        <FormControlLabel
          key={checkboxProps.value as string}
          {...formControlLabelProps}
          sx={(theme) => ({
            padding: theme.spacing(theme.tokens.spacing.sm),
            borderRadius: theme.tokens.borderRadius.md,
            borderStyle: "solid",
            borderWidth: "2px",
            inlineSize: "fit-content",
            alignItems: "center",
            borderColor: checkboxProps.checked ? theme.palette.secondary.main : "transparent",
            [`:not(.${checkboxClasses.disabled}):hover`]: {
              bgcolor: theme.palette.secondary.light
            },
            [`&.${checkboxClasses.disabled}`]: {
              borderColor: checkboxProps.checked ? theme.palette.action.disabled : "transparent"
            }
          })}
          control={
            <Checkbox
              {...checkboxProps}
              disabled={
                // Disable based on max selections if applicable
                (maxSelections && selectedOptions.length >= maxSelections && !checkboxProps.checked) ||
                // Disable other options if "None" is selected
                (isNoneOfTheAboveSelected && checkboxProps.value !== DoAnyApplyOption.NONE) ||
                // Disable "None" option if any other option is selected
                (checkboxProps.value === DoAnyApplyOption.NONE && hasOtherSelections)
              }
            />
          }
        />
      )}
    />
  )
}
